import { z } from "zod";
const schemaBitcoinGetXPubParams = z.object({
    accountId: z.string(),
});
const schemaBitcoinGetXPubResults = z.object({
    xPub: z.string(),
});
export const schemaBitcoinGetXPub = {
    params: schemaBitcoinGetXPubParams,
    result: schemaBitcoinGetXPubResults,
};
//# sourceMappingURL=BitcoinGetXPub.js.map